"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemClassName = exports.isClonedItem = exports.isActiveItem = void 0;

var Utils = _interopRequireWildcard(require("./index"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var isActiveItem = function isActiveItem() {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentIndex = state.currentIndex,
      items = state.items,
      infinite = state.infinite,
      _state$stagePadding = state.stagePadding,
      stagePadding = _state$stagePadding === void 0 ? {} : _state$stagePadding;

  if (infinite && (stagePadding.paddingLeft || stagePadding.paddingRight)) {
    currentIndex += 1;
  }

  var index = currentIndex + items;
  return i >= index && i < index + items;
};

exports.isActiveItem = isActiveItem;

var isClonedItem = function isClonedItem() {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var infinite = state.infinite,
      items = state.items,
      _state$slides = state.slides,
      slides = _state$slides === void 0 ? [] : _state$slides;
  return infinite === false && (i < items || i > slides.length + items - 1);
};

exports.isClonedItem = isClonedItem;

var itemClassName = function itemClassName() {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var animationProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isActive = isActiveItem(i, state) ? ' __active' : '';
  var isCloned = isClonedItem(i, state) ? ' __cloned' : '';
  var isAnimated = Utils.isAnimatedItem(i, animationProps) ? ' animated animated-out fadeOut' : '';
  return 'alice-carousel__stage-item' + isActive + isCloned + isAnimated;
};

exports.itemClassName = itemClassName;


//////////////////
// WEBPACK FOOTER
// ./~/react-alice-carousel/lib/utils/classnames.js
// module id = 704
// module chunks = 168707334958949